import {
	createSlice,
	createAsyncThunk,
	createEntityAdapter,
} from "@reduxjs/toolkit";
import { showLoader, hideLoader } from "store/misc/loaderSlice";
import { showMessage } from "store/misc/messageSlice";
import eventBookingService from "services/eventBookingService";

export const fetchEvents = createAsyncThunk(
	"vino/events/fetchList",
	async (_, { dispatch }) => {
		try {
			dispatch(showLoader());
			return await eventBookingService.list();
		} catch (e) {
			console.error(e);
			dispatch(
				showMessage({
					message: "Error occurred while getting events",
					variant: "error",
				})
			);
		} finally {
			dispatch(hideLoader());
		}
	}
);

export const cancelEvent = (id, isSubmitting) => (dispatch) => {
	const input = {
		id,
		changes: { isCancelling: isSubmitting },
	};
	dispatch(update(input));
};

const eventBookingsAdapter = createEntityAdapter({});

export const {
	selectAll: selectEventBookings,
	selectById: selectEventBookingById,
} = eventBookingsAdapter.getSelectors((state) => state.vino.eventBookings);

const eventBookingsSlice = createSlice({
	name: "vino/event-bookings",
	initialState: eventBookingsAdapter.getInitialState(),
	reducers: {
		update: eventBookingsAdapter.updateOne,
	},
	extraReducers: {
		[fetchEvents.fulfilled]: eventBookingsAdapter.setAll,
	},
});

export const { update } = eventBookingsSlice.actions;

export default eventBookingsSlice.reducer;
